/**
 * @desc sku报价模板下载
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/downloadImportTemp`, {
      method: "GET",

      ...options,
    }),
  );
}
